import { tryInsertSpaces } from "./index142.js";
function getSpaceInsertionScore(spaces, sortedApartments, sectionIndex, apartmentIndex) {
  const score = { totalUnusedArea: 0, invalid: 0 };
  let spacesToAdd = [...spaces];
  while (sectionIndex < sortedApartments.length && spacesToAdd.length > 0) {
    const result = tryInsertSpaces(spacesToAdd, sortedApartments[sectionIndex], apartmentIndex);
    score.totalUnusedArea += result.unusedArea;
    score.invalid += result.invalid;
    spacesToAdd = [...result.leftoverSpaces];
    sectionIndex++;
    apartmentIndex = 0;
  }
  score.invalid += spacesToAdd.length;
  return score;
}
export {
  getSpaceInsertionScore
};
//# sourceMappingURL=index138.js.map
